import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import FinishRegistrationRedirect from './FinishRegistrationRedirect';
import LoadingScreen from './LoadingScreen';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !currentUser) {
      navigate('/');
    }
  }, [currentUser, loading, navigate]);

  if (loading) return <LoadingScreen />;

  return currentUser ? <FinishRegistrationRedirect>{children}</FinishRegistrationRedirect> : null;
};

export default ProtectedRoute;
